var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiCard: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    position: 'relative',
                    borderRadius: '8px',
                    border: "1px solid ".concat(designTokens.color.gray.accent.value),
                    transition: 'box-shadow 0.15s ease-out',
                    '&:hover': {
                        boxShadow: designTokens.shadow.medium.value,
                        border: "1px solid ".concat(designTokens.color.gray.disabled.value), // just a darker grey: #c6c6c6
                    },
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
                action: {
                    margin: 0,
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: __assign({ padding: 0, marginTop: '8px', color: designTokens.color.gray.obsidian.value }, muiTypography.paragraphSmall),
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: 0,
                    flexDirection: 'column',
                    '> :not(:first-of-type)': {
                        margin: 'unset',
                    },
                    gap: '8px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=cardTheme.js.map